<template>
    <div>
        <filters :scope="filtersScope"></filters>
        <ConversionsTabs></ConversionsTabs>
        <StatisticTable
                        class="animated fadeIn"
                        :headColumns="headColumns"
                        :footColumns="footColumns"
                        :rows="rows"
                        :title="`${$t('pages.conversions')}`">
        </StatisticTable>
    </div>
</template>

<script>
  import Filters from '../../../components/Filters.vue'
  import API from '../../../api/API'
  import Storage from '../../../api/Storage'
  import { map } from 'lodash'
  import Helper from '../../../api/Helper'
  import TypeColor from '../../../assets/TypeColor'
  import StatisticTable from '../../../components/StatisticTable.vue'
  import ConversionsTabs from './ConversionsTabs.vue'
  import getSymbolFromCurrency from 'currency-symbol-map'

export default {
    name: 'Period',
    components: {
      Filters,
      StatisticTable,
      ConversionsTabs
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true,
          offerFilter: true,
          byManualFilter: true
        },
        isLoading: false,
        Storage: Storage,
        TypeColor: TypeColor,
        Helper: Helper,
        country: null,
        headColumns: [
          {label: this.$root.$t('statistic.offer'), field: 'offer', width: '200px'},
          {label: this.$root.$t('statistic.total'), field: 'total'},
          {label: this.$root.$t('statistic.processed'), field: 'processed', colspan: 2},
          {label: this.$root.$t('statistic.accepted'), field: 'accepted'},
          {label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2},
          {label: this.$root.$t('statistic.error'), field: 'error', colspan: 2},
          {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2},
          {label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2},
          {label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2},
          {label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback', colspan: 2},
          {label: this.$root.$t('statistic.approve'), field: 'approve', width: '50px'},
          {label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px'},
          { label: this.$root.$t('statistic.ad_approved'), field: 'ad_approved' },
          { label: this.$root.$t('statistic.ad_pre_approved'), field: 'ad_pre_approved' },
          { label: this.$root.$t('statistic.ad_difference'), field: 'ad_difference' }
        ],
        rows: [],
        footColumns: {},
        offers: []
      }
    },
    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    methods: {
      calculateRows () {
        this.$root.$emit('data_loading')
        this.rows = []
        this.footColumns = {}
        let oldArrCurrency = []
        let newArrCurrency = []
        API.getConversionsPeriodStatistic().then(response => {
          map(response.data, d => {
            oldArrCurrency.push(d.local_currency.split(','))
            oldArrCurrency.forEach(array => {
              array.forEach(item => {
                newArrCurrency.push(item)
              })
            })
          })
          let filterCurrency = newArrCurrency.filter((item, index) => {
            return newArrCurrency.indexOf(item) === index
          })
          this.offers = Storage.offers.slice(0)
          let sumTotal = 0
          let sumProcessed = 0
          let countProcessed = 0
          let sumAccepted = 0
          let countAccepted = 0
          let sumCanceled = 0
          let countCanceled = 0
          let sumError = 0
          let countError = 0
          let sumReturn = 0
          let countReturn = 0
          let sumPaid = 0
          let countPaid = 0
          let sumAverageBill = 0.0
          let sumAverageBillLocal = 0.0
          let sumAverageBuyback = 0.0
          let sumAverageBuybackLocal = 0.0
          let sumAdApproved = 0
          let sumAdPreApproved = 0
          let sumAdDifference = 0
          const count = Object.keys(response.data).length
          // парсим
          map(response.data, (d) => {
            this.rows.push({
              offer: {
                value: `<b>${Helper.findCountry(d.country_id).name}</b> | ${Helper.getOfferTitle(this.offers, d.offer_id)}`
              },
              total: {
                value: d.total,
                bg: true
              },
              processed: {
                value: d.processed,
                bg: true,
                bgg: Helper.renderGistPart(d.total, d.processed),
                isCollspaned: true
              },
              processedPercent: {
                value: Helper.percents(d.total, d.processed),
                bgg: Helper.renderGistPart(d.total, d.processed, true)
              },
              accepted: {
                value: d.approved,
                bg: true
              },
              canceled: {
                value: d.canceled,
                bgg: Helper.renderGistPart(d.total, d.canceled),
                isCollspaned: true
              },
              canceledPercents: {
                value: Helper.percents(d.total, d.canceled),
                bgg: Helper.renderGistPart(d.total, d.canceled, true)
              },
              error: {
                value: d.error,
                bgg: Helper.renderGistPart(d.total, d.error),
                isCollspaned: true
              },
              errorPercents: {
                value: Helper.percents(d.total, d.error),
                bgg: Helper.renderGistPart(d.total, d.error, true)
              },
              return: {
                value: d.return,
                bgg: Helper.renderGistPart(d.approved, d.return),
                isCollspaned: true
              },
              returnPercents: {
                value: Helper.percents(d.approved, d.return),
                bgg: Helper.renderGistPart(d.approved, d.return, true)
              },
              paid: {
                value: d.paid,
                bgg: Helper.renderGistPart(d.approved, d.paid),
                isCollspaned: true
              },
              paidPercents: {
                value: Helper.percents(d.approved, d.paid),
                bgg: Helper.renderGistPart(d.approved, d.paid, true)
              },
              averageBill: {
                value: '$ ' + d.average_bill.toFixed(2),
                bgg: Helper.renderGistPart(d.average_bill, d.rate, true)
              },
              averageBillLocal: {
                value: `${Helper.newAverageBillDay(d.average_bill, d.rate, getSymbolFromCurrency(d.local_currency))}`,
                bgg: Helper.renderGistPart(d.average_buyout, d.rate, true)
              },
              averageBuyback: {
                value: '$ ' + d.average_buyout.toFixed(2)
              },
              averageBuybackLocal: {
                value: `${Helper.newAverageBillDay(d.average_buyout, d.rate, getSymbolFromCurrency(d.local_currency))}`
              },
              approve: {
                value: Helper.percents(d.total, d.approved),
                bgg: Helper.renderSingleGist(d.total, d.approved)
              },
              approvedFromValid: {
                value: `${(d.approved_from_valid).toFixed(1)}%`
              },
              ad_approved: {
                value: d.ad_approved ? Number(d.ad_approved.toFixed(2)) : 0
              },
              ad_pre_approved: {
                value: d.ad_pre_approved ? Number(d.ad_pre_approved.toFixed(2)) : 0
              },
              ad_difference: {
                value: isNaN(d.ad_approved - d.ad_pre_approved) ? 0 : Number((d.ad_approved - d.ad_pre_approved).toFixed(2))
              }
            })
            sumTotal += d.total
            if (d.processed > 0) {
              sumProcessed += d.processed
              countProcessed++
            }
            if (d.approved) {
              sumAccepted += parseInt(d.approved)
              countAccepted++
            }
            if (d.approved > 0) {
              sumAverageBill += parseFloat(d.average_bill) * d.approved
              sumAverageBuyback += parseFloat(d.average_buyout) * d.paid
              sumAverageBillLocal += parseFloat(d.average_bill * d.rate) * d.approved
              sumAverageBuybackLocal += parseFloat(d.average_buyout * d.rate) * d.paid
              this.localCurrencySymbol = getSymbolFromCurrency(d.local_currency)
            }
            if (d.canceled > 0) {
              sumCanceled += d.canceled
              countCanceled++
            }
            if (d.error > 0) {
              sumError += d.error
              countError++
            }
            if (d.return > 0) {
              sumReturn += d.return
              countReturn++
            }
            if (d.paid > 0) {
              sumPaid += d.paid
              countPaid++
            }
            if (d.ad_approved > 0) {
              sumAdApproved += parseInt(d.ad_approved)
            }
            if (d.ad_pre_approved > 0) {
              sumAdPreApproved += parseInt(d.ad_pre_approved)
            }

            sumAdDifference += isNaN(d.ad_approved - d.ad_pre_approved) ? 0 : d.ad_approved - d.ad_pre_approved
          })
          this.footColumns = {
            label: {
              value: this.$root.$t('statistic.in_total')
            },
            total: {
              value: `${sumTotal} (${Helper.average(sumTotal, count)})`
            },
            processed: {
              value: `${sumProcessed} (${Helper.average(sumProcessed, countProcessed)})`
            },
            processedPercent: {
              value: Helper.percents(sumTotal, sumProcessed)
            },
            accepted: {
              value: `${sumAccepted} (${Helper.average(sumAccepted, countAccepted)})`
            },
            canceled: {
              value: `${sumCanceled} (${Helper.average(sumCanceled, countCanceled)})`
            },
            canceledPercents: {
              value: Helper.percents(sumTotal, sumCanceled)
            },
            error: {
              value: `${sumError} (${Helper.average(sumError, countError)})`
            },
            errorPercents: {
              value: Helper.percents(sumTotal, sumError)
            },
            return: {
              value: `${sumReturn} (${Helper.average(sumReturn, countReturn)})`
            },
            returnPercents: {
              value: Helper.percents(sumAccepted, sumReturn)
            },
            paid: {
              value: `${sumPaid} (${Helper.average(sumPaid, countPaid)})`
            },
            paidPercents: {
              value: Helper.percents(sumAccepted, sumPaid)
            },
            averageBill: {
              value: Helper.averageBillDayCount(sumAverageBill, sumAccepted)
            },
            averageBillLocal: {
              value: filterCurrency.length === 1 ? `${Helper.newLocalAverageBill(sumAverageBillLocal, sumAccepted, this.localCurrencySymbol)}` : '-'
            },
            averageBuyback: {
              value: Helper.averageBillDayCount(sumAverageBuyback, sumPaid)
            },
            averageBuybackLocal: {
              value: filterCurrency.length === 1 ? `${Helper.newLocalAverageBill(sumAverageBuybackLocal, sumPaid, this.localCurrencySymbol)}` : '-'
            },
            approve: {
              value: Helper.percents(sumTotal, sumAccepted)
            },
            approvedFromValid: {
              value: Helper.approvedFromValid(sumAccepted, sumTotal, sumError)
            },
            ad_approved: {
              value: sumAdApproved
            },
            ad_pre_approved: {
              value: sumAdPreApproved
            },
            ad_difference: {
              value: sumAdDifference
            }
          }
          this.$root.$emit('data_loaded')
        }).catch(response => {
          this.$root.$emit('data_loaded')
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Period.vue?f7044b58